import { PermissionOperation, Scope } from 'generated/graphql';
import { SuperPermissionResource, UserType } from 'v2/core/entities/user';
import { useGetUser } from 'v2/core/services/user';
import { useIsAuthorized } from '../components/CanAccess/hooks';

export const useGetArtefactScope = () => {
  const { type: userType } = useGetUser();

  const canAccessDiscoverability = useIsAuthorized({
    resource: SuperPermissionResource.Discoverability,
    operation: PermissionOperation.Write,
  });

  const isViewerType = userType === UserType.Viewer;

  if (isViewerType || canAccessDiscoverability) {
    return Scope.Private;
  }

  return Scope.Public;
};
